module.exports = __webpack_public_path__ + "img/Img16_212121_BgFo-18-Vase77.fb3907cc.jpg";